import axios from './axiosInstances/axiosInstance';

export const applyRewardToBasket = (basketId, printedCardNumber, references) => {
  return axios.put(`baskets/${basketId}/loyaltyrewards/byref?printedCardNumber=${printedCardNumber}`, references);
};
